<template>
  <cropper
    :src="src"
    :stencil-props="stencilProps"
    :min-width="minWidth"
    :min-height="minHeight"
    @change="change"
  />
</template>

<script>
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

export default {
  name: 't-cropper',
  components: {
    Cropper,
  },
  props: {
    src: String,
    aspectRatio: Number,
    minWidth: Number,
    minHeight: Number,
  },
  computed: {
    stencilProps() {
      return {
        aspectRatio: this.aspectRatio,
      };
    },
  },
  methods: {
    change(result) {
      this.$emit('input', result);
      this.$emit('change', result);
    },
  },
};
</script>
